import {useMutation} from "@tanstack/react-query";
import {updateAuthUser} from "../services/UserService";

// Atomic update via the authz-aware endpoint (PUT /api/v3/auth/users/{id}, TMMFX-3451).
// Call .mutate({id, payload}, {onSuccess, onError}).
export function useAuthUserUpdate() {
    return useMutation({
        mutationFn: ({id, payload}) => updateAuthUser(id, payload),
    });
}
